<template>
  <div class="login-box">
    <div class="login-main-box">
      <div>
        <div style="width: 120px; height: 120px">
          <img src="../../../assets/images/loginIMG.png"
               style="border-radius: 50%"
               alt />
        </div>
        <!-- <van-row class="login-title">
          <van-col span="24">登录账号</van-col>
        </van-row>
        <van-row class="login-main">
          <van-col span="24"></van-col>
        </van-row>-->
      </div>

      <van-row class="login-bottom">
        <van-col span="24">
          <van-button style="margin-top: 20px"
                      :loading="loading"
                      size="large"
                      type="primary"
                      plain
                      round
                      block
                      @click="onTestSubmit">使用测试账号登录</van-button>
        </van-col>
      </van-row>
      <van-dialog v-model="IsShow"
                  showCancelButton
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  confirm-button-color="#ee0a24"
                  @confirm="confirm()">
        <div class="passWordField">
          <van-field label-width="20vw"
                     v-model="password"
                     placeholder="请输入密码"
                     clearable
                     label="密码">
          </van-field>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  Field,
  Button,
  Notify,
  Dialog,
  Toast,
} from "vant";
import { mapGetters, mapActions } from "vuex";
import service from "../../api/redirect/index";
import page from '../../api/page';
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Notify.name]: Notify,
  },
  data () {
    return {
      password: "", //测试
      password1: "", //测试
      IsShow: false,
      IsLoginShow: false,
      phoneNumber: "",
      loading: false,
      urlParmams: {},
      shareUrl: "",
    };
  },
  computed: {
    ...mapGetters(["userInfo", "bankCardStatus", "agentShow"]),
  },
  methods: {
    ...mapActions(["wxLogin", "statusOut", "saveBankStatus", "buyAgentStatus"]),
    // need password test  yan olV-ewXYgxgZVPwsU9b3gI6XDwI8  HAO 	oWMCL59lUqGl3oc9iT4im4odMRyw   olV-ewbgtlck6wWlheh0a8xMw3vo  yu散户
    // 	oWMCL59lUqGl3oc9iT4im4odMRyw win  olV-ewYz-WlKYpgjmoxvokYTSx_c  meng   olV-ewRZe0skSn7DOWn_qOjdDKs8  summer olV-ewURsp9lJp7QvfyXt82a2mw8 l olV-ewb8u4eHRIrG4KoxBfyITabg 伟
    // 测试
    // lhy 修改（此处为测试环境的登录）
    confirm (password) {
      if (this.password.trim() !== "") {
        // openid测试登录
        console.log(this.password, 'this.password')
        service
          .wxLoginTest(this.password, null, null, null, null)
          .then((res) => {
            if (res.statusCode == 200) {
              this.wxLogin(res.data).then(() => {
                // 代买状态
                // -----------原有代码---------------------
                console.log(this.agentShow, 174);
                this.buyAgentStatus({ show: false });
                this.$router.replace({
                  path: '/page',
                });
                // -------------------------------
              });
            } else {
              console.log(this.password, 111)
              this.password = ''
            }
          }).catch(err => {
            this.password = ''
          });
      } else {
        Toast("请输入正确的密码");
        this.IsShow = false;
      }
    },

    onTestSubmit () {
      this.IsShow = true;
    },
  },
  mounted () {
    let obj = {
      color:
        this.bankCardStatus !== null && this.bankCardStatus.color
          ? this.bankCardStatus.color
          : 0,
    };
    console.log(webconfig.isDebugger, 159);
    this.saveBankStatus(obj);
  },
};
</script>

<style lang="less">

.login {
  &-box {
    position: fixed;
    width: 100%;
    bottom: 70px;
    img {
      width: 100%;
      height: 100%;
    }

  }

  &-close {
    font-size: 2em;
    color: #666;
  }

  &-close-box {
    text-align: right;
  }

  &-title {
    margin-top: 5%;
    font-size: 6.2vw;
    text-align: center;
  }

  &-main-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &-main {
    margin: 8% 0;
  }

  &-group {
    margin-bottom: 15px;
  }

  &-bottom {
    height: 100px;
    width: 80vw;
    margin-top: 25vw;
  }

  &-links {
    padding: 15px 0;
    font-size: 12px;
    text-align: center;
    background-color: #fff;

    .van-icon {
      display: block;
      font-size: 24px;
    }
  }
}
</style>
